import Vue from 'vue';
import Router from 'vue-router';
import CalcProspect from './calc-prospect.vue';
import CalcPartner from './calc-partner.vue';
import FormClubPartner from './form-partner.vue';
import FormClubProspect from './form-prospect.vue';
import Dashboard from './dashboard.vue';
import CalcIX from './ix/calc-ix.vue';
import FormIX from './ix/form-ix.vue';
import CalcIXPartner from './ix/calc-ix-partner.vue';
import FormIXPartner from './ix/form-ix-partner.vue';
import DashboardIX from './ix/dashboard-ix.vue';

Vue.use(Router);

const appRoutes = [
  {
    path: '/Prospect',
    name: 'CalcProspectForm',
    component: FormClubProspect,
  },
  {
    path: '/Prospect/:clubName/:existingFlexibleMembership',
    name: 'ClubProspect',
    component: CalcProspect,
  },
  {
    path: '/Prospect/:clubName/:existingFlexibleMembership/:compareOwnFlexi',
    name: 'ClubProspect',
    component: CalcProspect,
  },
  {
    path: '/IX',
    name: 'IXForm',
    component: FormIX,
  },
  {
    path: '/IX/Prospect',
    name: 'IXProspectForm',
    component: FormIX,
  },
  {
    path: '/IX/Prospect/:clubName/:existingFlexibleMembership',
    name: 'IXProspectCalculator',
    component: CalcIX,
  },
  {
    path: '/IX/Prospect/:clubName/:existingFlexibleMembership/:compareOwnFlexi',
    name: 'IXProspectCalculator',
    component: CalcIX,
  },
  {
    path: '/IX/Partner',
    name: 'IXPartnerForm',
    component: FormIXPartner,
  },
  {
    path: '/IX/Partner/:clubId',
    name: 'IXPartnerCalculator',
    component: CalcIXPartner,
  },
  {
    path: '/Partner',
    name: 'ClubPartnerForm',
    component: FormClubPartner,
  },
  {
    path: '/Partner/:clubId',
    name: 'ClubPartner',
    component: CalcPartner,
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: Dashboard,
  },
  {
    path: '/IX/Dashboard',
    name: 'IXDashboard',
    component: DashboardIX,
  },
];

const routes = [...appRoutes];

const router = new Router({
  mode: 'hash',
  routes,
});

export default router;
